import { render, staticRenderFns } from "./CancelPage.vue?vue&type=template&id=0ea81b88&scoped=true"
import script from "./CancelPage.vue?vue&type=script&lang=js"
export * from "./CancelPage.vue?vue&type=script&lang=js"
import style0 from "./CancelPage.vue?vue&type=style&index=0&id=0ea81b88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea81b88",
  null
  
)

export default component.exports